import React from 'react';
import { Link } from '@mui/material';
import { parseChatMessageSegments } from '../utils/formatChatMessage';

type ChatMessageContentProps = {
  text: string;
  /** Link colour for contrast on user vs bot bubbles */
  linkColor?: string;
};

const ChatMessageContent: React.FC<ChatMessageContentProps> = ({ text, linkColor }) => (
  <>
    {parseChatMessageSegments(text).map((segment, index) => {
      if (segment.type === 'link') {
        return (
          <Link
            key={index}
            href={segment.href}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              color: linkColor || 'primary.main',
              fontWeight: 500,
              wordBreak: 'break-word',
            }}
          >
            {segment.content}
          </Link>
        );
      }
      if (segment.type === 'bold') {
        return <strong key={index}>{segment.content}</strong>;
      }
      return <React.Fragment key={index}>{segment.content}</React.Fragment>;
    })}
  </>
);

export default ChatMessageContent;
